import React from 'react';
interface PaymentMethodsProps {
  onNavigate?: (pageId: string) => void;
}
const paymentLogos = [{
  name: 'Visa',
  src: 'https://cdn.magicpatterns.com/uploads/n1zLbM27UgeLk9Z8ehpnAg/Visa_Logo.png'
}, {
  name: 'Mastercard',
  src: 'https://cdn.magicpatterns.com/uploads/k9ED3mNyq4mpmcVbR7oYqN/MasterCard_Logo.png'
}, {
  name: 'UnionPay',
  src: 'https://cdn.magicpatterns.com/uploads/r5WqGY6n6RhSG46P3jhCLA/UnionPay_Logo.png'
}, {
  name: 'PayPak',
  src: 'https://cdn.magicpatterns.com/uploads/n49hwAt3PDuCKUn5uZ1jWu/PayPak_Logo.png'
}, {
  name: 'RAAST',
  src: 'https://cdn.magicpatterns.com/uploads/kdN9XNZ2i2dAFUJvtY4BQB/RAAST_Logo.png'
}];
export function PaymentMethods({
  onNavigate
}: PaymentMethodsProps) {
  return <section className="py-12 border-t border-gray-200 mt-8" data-id="element-232">
      <h2 className="text-2xl font-medium text-gray-900 mb-6" data-id="element-233">
        Payment methods
      </h2>
      <p className="text-gray-600 mb-8 max-w-3xl leading-relaxed" data-id="element-234">
        Offer your customers their preferred way to pay. We support a wide range
        of global and local payment methods to help you increase conversion
        rates and expand your business globally.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-235">
        {paymentLogos.map(logo => <div key={logo.name} onClick={() => onNavigate?.('payment-methods')} className="h-24 bg-white border border-gray-200 rounded-lg flex items-center justify-center hover:shadow-md transition-shadow cursor-pointer p-4" data-id="element-236">
            <img src={logo.src} alt={logo.name} className="max-h-14 max-w-full object-contain" data-id="element-237" />
          </div>)}
      </div>
    </section>;
}